import React from 'react';
import { LayerType } from '@/version-types';
import { CoreAPI } from '../../core';

/** 图层快捷操作菜单 */
export class ShortcutMenu {
    /** 菜单数据 */
    private data: React.ReactNode | null = null;
    /** 快捷操作菜单打开事件 */
    private eventName = 'gs-shortcut-menu';
    /** 隐藏菜单 */
    private hideEventName = 'gs-shortcut-hide';
    /** 自定义快捷操作菜单变化事件 */
    private customMenuEventName = 'gs-shortcut-custom-menu';
    /** 自定义快捷操作菜单数据 */
    private customMenuList: {
        layerType: LayerType;
        menu: string;
        data: React.ReactNode;
    }[] = [];
    /** 自定义替换菜单 */
    private replaceMenuData: React.ReactNode;

    constructor(private identity: string) {}

    /** 设置快捷操作菜单 */
    set(data: React.ReactNode | null) {
        this.data = data;
        CoreAPI(this.identity).events.emit(this.eventName, data);
    }

    /** 获取快捷操作菜单 */
    get() {
        return this.data;
    }

    /** 监听快捷操作菜单 */
    onMenu(callback: (data: React.ReactNode) => void) {
        return CoreAPI(this.identity).events.on(this.eventName, callback);
    }

    /** 添加快捷操作自定义菜单 */
    addCustomMenu(layerType: LayerType, menu: string, data: React.ReactNode) {
        const hasMenu = this.customMenuList.find((item) => item.layerType === layerType && item.menu === menu);
        // 如果已经加入过了就不再重复加入
        if (hasMenu) {
            hasMenu.data = data;
            this.customMenuList = [...this.customMenuList];
            return;
        }
        this.customMenuList.push({
            layerType,
            menu,
            data,
        });
        this.customMenuList = [...this.customMenuList];
        CoreAPI(this.identity).events.emit(this.customMenuEventName);
    }

    /** 移除快捷操作自定义菜单 */
    removeCustomMenu(layerType: LayerType, menu: string) {
        this.customMenuList = this.customMenuList.filter((item) => item.layerType !== layerType || item.menu !== menu);
        CoreAPI(this.identity).events.emit(this.customMenuEventName);
    }

    /** 替换菜单 */
    replaceMenu(menu: React.ReactNode) {
        this.replaceMenuData = menu;
        CoreAPI(this.identity).events.emit(this.customMenuEventName, menu);
    }

    /** 获取替换菜单 */
    getReplaceMenu() {
        return this.replaceMenuData;
    }

    /** 获取快捷操作自定义菜单 */
    getCustomMenu() {
        return this.customMenuList;
    }

    /** 自定义菜单变化事件 */
    onCustomMenu(callback: () => void) {
        return CoreAPI(this.identity).events.on(this.customMenuEventName, callback);
    }

    /** 监听隐藏菜单隐藏 */
    onHide(callback: (isHide: boolean) => void) {
        return CoreAPI(this.identity).events.on(this.hideEventName, callback);
    }

    /** 隐藏菜单 */
    hide(isHide: boolean) {
        CoreAPI(this.identity).events.emit(this.hideEventName, isHide);
    }
}
